(function () {
    'use strict';

    angular
        .module('app.addUserToAccount')
        .factory('addUserToAccountService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getCompanyAndUser(loader) {
                    var url_getCompanyAndUser = $rootScope.apiUrl + 'admin/getCompanyAndUser';
                    return handleRequest(url_getCompanyAndUser, 'GET', null, loader);
                }

                function searchCompanyByName(account_name, loader) {
                    var url_searchCompanyByName = $rootScope.apiUrl + 'admin/searchCompanyByName/' + account_name;
                    return handleRequest(url_searchCompanyByName, 'GET', null, loader);
                }

                function addUserToAccount(params, loader) {
                    var url_addUserToAccount = $rootScope.apiUrl + 'admin/addUserToAccount';
                    return handleRequest(url_addUserToAccount, 'POST', params, loader);
                }

                service.getCompanyAndUser = getCompanyAndUser;
                service.searchCompanyByName = searchCompanyByName;
                service.addUserToAccount = addUserToAccount;

                return service;
            }
        ]);
})();
